import router from '@/router';
import { Message,MessageBox} from 'element-ui'

const state = {
  userInfo:sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {},
  isLogin:sessionStorage.getItem('isLogin'),
  userMenuList:localStorage.getItem('userMenuList') ? JSON.parse(localStorage.getItem('userMenuList')) : [],//用户的所有菜单
  treeMenuList:localStorage.getItem('treeMenuList') ? JSON.parse(localStorage.getItem('treeMenuList')) : [],
  topMenuIndex:localStorage.getItem('topMenuIndex') ? localStorage.getItem('topMenuIndex') : 0,//顶部菜单选中的索引
  leftMenuIndex:0,//左侧菜单索引
  leftChildMenuIndex:localStorage.getItem('leftChildMenuIndex') ? localStorage.getItem('leftChildMenuIndex') : 0,//左侧子级菜单索引
  topMenu:localStorage.getItem('topMenu') ? JSON.parse(localStorage.getItem('topMenu')) : [],//顶部菜单
  leftMenu:[],//左侧菜单
}
const mutations = {
}

const actions = {
  /**
   * @description 登录
   * @param {Object} context
   * @param {Object} payload username {String} 用户账号
   * @param {Object} payload password {String} 密码
   * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
   */
  loginSuccess ({state, dispatch,commit },{userInfo}) {
    sessionStorage.setItem('isLogin',true);
    sessionStorage.setItem('userInfo',JSON.stringify(userInfo));
    state.isLogin = true;
    state.userInfo = userInfo;

    /* // 设置cookie
    Cookies.set('token',"");
    Cookies.set('userInfo',JSON.stringify(userInfo));
    Cookies.set('isLogin',true); */
  },

  /**
   * @description 注销用户并返回登录页面
   * @param {Object} context
   * @param {Object} payload confirm {Boolean} 是否需要确认
   */
  logout ({ commit, dispatch }, { confirm = false } = {}) {
    /**
     * @description 注销
     */
    function logout () {
      sessionStorage.clear();
      localStorage.clear();
      // 跳转路由
      router.push({name:'login'});
    }
    // 判断是否需要确认
    if (confirm) {
      MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
        type: 'warning'
      }).then(() => {
        logout()
      });
    } else {
      logout()
    }
  },

  /**
   * 登录后的用户信息
   *
   */
  getAccountInfo({state,commit, dispatch }){
    let userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {};
    state.userInfo = userInfo;
  },

  /**
   * 设置登录后在菜单
   */
  setUserMenu({state,commit,dispatch},{userMenuList}){
    let home = {
      level: 1,
      parentResourceId:0,
      resourceCode:"home",
      resourceHref:"/",
      resourceId:1,
      resourceName:"首页",
      resourceType:"1",
      value: "首页"
    };

    let allMenu = [];
    if(userMenuList){
      allMenu = userMenuList;
      let isHome = userMenuList.findIndex(v=>v.resourceHref == '/');
      if(isHome === -1){//不存在首页。加首页
        allMenu.push(home);
      }
    }

    // 将数据存储为 以 tid 为 KEY 的 map 索引数据列
    var map = {};
    //顶部菜单
    let topMenu = [];
    let treeMenuList = [];//树状菜单
    allMenu.forEach((item)=>{
      // 删除 所有 children,以防止多次调用
      delete item.children;
      map[item.resourceId] = item;
      //顶部菜单
      if(item.parentResourceId == 0) topMenu.push(item);
    });

    allMenu.forEach((item)=>{
      var parent = map[item.parentResourceId];
      if (parent) {
        (parent.children || (parent.children = [])).push(item);
      } else {
        // 如果没有在map中找到对应的索引tid,那么直接把 当前的item添加到 val结果集中，作为顶级
        treeMenuList.push(item);
      }
    });


    state.userMenuList = allMenu;
    state.treeMenuList = treeMenuList;
    state.topMenu = topMenu;

    //设置用户菜单
    localStorage.setItem('userMenuList',JSON.stringify(allMenu));
    //设置用户顶部菜单
    localStorage.setItem('topMenu',JSON.stringify(topMenu));
    //树状顶部菜单
    localStorage.setItem('treeMenuList',JSON.stringify(treeMenuList));
  },

  //设置顶部菜单
  setTopMenuIndex({state,commit},topIndex){
    state.topMenuIndex = topIndex;
  },

  //设置顶部菜单
  setTopMenu({state,commit},{menuList}){
    state.topMenu = menuList;
    //console.log(state.topMenu,'========= 顶部菜单22222 =======');
  },
  //设置左侧菜单
  setLeftMenu({state,dispatch,commit},{topIndex,routeName}){
    let res = state.treeMenuList.find(v=> v.resourceId === topIndex);

    if(res && res.children){
      state.leftMenu = res.children;
      let childRes = state.userMenuList.find(v=>v.resourceCode == routeName);
      if(childRes.resourceType == 3){//菜单
        state.leftMenuIndex = childRes.parentResourceId;
      }else if(childRes.resourceType == 4){//功能
        let parentRes = state.userMenuList.find(v=>v.resourceId === childRes.parentResourceId);
        state.leftMenuIndex = parentRes.parentResourceId;
      }
    }else{
      state.leftMenu = [];
    }
  },


  //顶部菜单切换 - 动态获取左侧菜单
  topMenuTab({state,dispatch,commit },topIndex){
    debugger;
    state.topMenuIndex = topIndex;
    //获取左侧菜单
    let leftMenu = [];
    let leftMenuIndex = 0;
    let leftChildMenuIndex = 0;
    let res = state.treeMenuList.find(v=> v.resourceId === topIndex);  

    if(res && res.children){
      leftMenu = res.children;
      let toName = res.children[0].children ? res.children[0].children[0].resourceCode : "home";
      leftMenuIndex = res.children[0].resourceId;
      leftChildMenuIndex = res.children[0].children ? res.children[0].children[0].resourceId : "0";
      router.push({name:toName});
    }
    state.leftMenu = leftMenu;
    state.leftMenuIndex = parseInt(leftMenuIndex);
    state.leftChildMenuIndex = parseInt(leftChildMenuIndex);
  }
}
export default{
  namespaced: true,
  state,
  mutations,
  actions
}
